<template>
  <transition name="modal-fade">
    <div>
      <div class="modal-mask" ref="mymodal" @click="outsideClose">
        <div
          class="modal-base modal-center"
          onclick="event.stopPropagation();"
          role="dialog"
          aria-modal="true"
        >
          <st-card
            :class="classList"
            :isLoading="isLoading"
            :width-size="widthSize"
            :style="style"
            :error="error"
            style="pointer-events: auto"
            :loadingMessage="loadingMessage"
            :errorMessage="errorMessage"
            :unhandledErrorMessage="unhandledErrorMessage"
            :aria-label="ariaLabel"
            :is-modal="true"
          >
            <div :class="isHidden">
              <slot name="header">
                <i
                  v-if="onClose"
                  class="fas fa-times closeButton"
                  @click="close"
                ></i>
              </slot>

              <slot name="body"></slot>

              <slot name="footer"></slot>
            </div>
          </st-card>
        </div>
      </div>
      <div class="modal-background"></div>
    </div>
  </transition>
</template>

<script>
import StCard from "../card/Card.vue";
export default {
  name: "st-modal",
  components: {
    StCard,
  },
  props: {
    onClose: {
      type: Function,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    loadingMessage: {
      type: String,
    },
    large: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    mega: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object,
    },
    width: {
      type: Number,
      default: 0,
    },
    disableOutsideClick: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: "",
    },
    unhandledErrorMessage: {
      type: String,
      default: "",
    },
    ariaLabel: {
      type: String,
      default: "",
    },
  },

  computed: {
    classList: function () {
      return ["st-modal", this.large && "lg", this.small && "sm"];
    },
    widthSize: function () {
      if (this.mega) return "mega-width";
      else if (!this.large) return "md-width";
      else if (this.large) return "lg-width";
      else return "";
    },
    style: function () {
      if (this.width > 0) {
        return `max-width: ${this.width}em`;
      } else {
        return "";
      }
    },
    isHidden: function () {
      return this.isLoading ? "hidden" : "";
    },
    modalMaxWidth: function () {
      if (this.width > 0) {
        return this.width;
      } else if (this.mega) return 88.25;
      else if (!this.large) return 36;
      else if (this.large) return 48.5;
      return 100;
    },
  },

  methods: {
    close: function () {
      if (this.onClose) {
        this.onClose();
      }
    },
    outsideClose: function () {
      if (this.disableOutsideClick || this.isLoading) return;

      if (this.onClose) {
        this.onClose();
      }
    },
    escHandler(e) {
      if (e.keyCode == 27) {
        this.$emit("esc-close");
      }
    },
  },
  mounted() {
    document.body.classList.add("modal-opened");
    let modalHeight = this.$refs.mymodal.scrollHeight;
    let windowHeight = window.innerHeight;

    //If scrollbar, add padding to body to avoid jitter
    if (modalHeight > windowHeight)
      document.body.style.paddingRight = "1.0625em";

    //Listening for esc when modal is open but not necessarily in focus (@keyup.esc only works when element is in focus)
    document.addEventListener("keyup", this.escHandler);
  },
  // eslint-disable-next-line vue/no-deprecated-destroyed-lifecycle
  destroyed() {
    document.body.classList.remove("modal-opened");
    document.body.style.removeProperty("padding-right");
    document.removeEventListener("keyup", this.escHandler);
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";
.modal-background {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9998;
  background-color: rgba(249, 248, 245, 0.95);
}

.modal-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  outline: 0;
  overflow-y: auto;
  display: block;
}

.modal-base {
  position: relative;
  width: auto;
  pointer-events: none;
  margin-top: $xl;
  @include medium {
    padding: 2.25em 1.5em;
    margin: 1.75em auto;
  }
}

.modal-center {
  @include medium {
    min-height: calc(100% - (1.75em * 2));
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    justify-content: center;
  }
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.1s linear;
}
.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.st-modal {
  @include medium {
    margin: 0em 0.3125em 0em 0.3125em;
    &.st-card.md-width {
      width: rem-calc(500);
    }
    &.st-card.lg-width {
      width: rem-calc(900);
    }
  }

  .st-modal-header {
    margin-bottom: $lg;
    h1,
    h2,
    h3 {
      margin-top: 0;
    }
  }

  .st-modal-footer {
    display: flex;
    flex-direction: column;
    margin-top: $lg;
    justify-content: center;
    button {
      margin-top: $md;
    }
  }
  &.lg-width {
    .st-modal-footer {
      @include medium {
        flex-direction: row;
        button:not(:last-child) {
          margin-right: $sm;
        }
        button:not(:first-child) {
          margin-left: $sm;
        }
      }
    }
  }

  .closeButton {
    color: #9e9692;
    float: right;
    top: 3.6875em;
    right: 1.5em;
    position: absolute;
    width: 1em;
    height: 1em;
  }

  .hidden {
    visibility: hidden;
  }
}
</style>
